<template>
  <!-- 导航开始 -->
  <header
    :class="{ 'bg-color': isTop }"
    class="ny-container-header"
    @mouseover.stop.prevent="hover()"
    @mouseleave.stop.prevent="leave()"
  >
    <div class="flex-row flex-between details">
      <div class="ny-container-header-left">
        <div class="logo">
          <img src="@/assets/logo.png" />
        </div>
        <router-link
          :to="{ name: item.path }"
          @mouseover.native="mouseOver(index)"
          @mouseleave.native="mouseLeave()"
          @click.native="handleClick(index)"
          :class="{ active: num === index }"
          class="item"
          v-for="(item, index) in navList"
          :key="index"
        >
          {{ item.name }}</router-link
        >
      </div>
      <div class="ny-container-header-right flex-row flex-end">
        <div class="title flex-row">
          <p :class="{ hot: isTop }">全国服务热线:&nbsp;0771-555-5555</p>
          <a  href="https://hk.07715555555.com" target="_blank" class="btn" :class="{'btn-active':isTop}">差旅预订</a>
        </div>
      </div>
    </div>
    <div class="fixed-up pointer flex-end flex-row" v-show="upIcon" @click="goUp">
      <div class="centent flex-start flex-column">
        <div class="item flex-center"><div class="logo"></div></div>
      </div>
    </div>
  </header>
  <!-- 导航结束 -->
</template>
<script>
 let item=document.getElementsByClassName("item");
export default {
  name: "navigation",
  props: {
    count: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      isTop: false,
      top: "",
      val: 0,
      num: 0,
      upIcon:false,
      isActive: false,
      navList: [
        { path: "index", name: "首页" },
        { path: "solution", name: "解决方案" },
        // { path: "conference", name: "红学" },
        { path: "aboutus", name: "关于我们" },
        { path: "joinus", name: "加入我们" },
      ],
    };
  },
  watch: {
    top(newName) {
      this.newTop = newName;
    },
    count(newVal) {
      this.num = newVal;
      this.val = newVal;
    },
  },
  created() {

  },
  computed: {},
  methods: {
    //监听滚动条事件
    getScroll() {
      let scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
      this.top = scrollTop;
      if(scrollTop>500){
        this.upIcon= true;
      }else{
        this.upIcon= false;
      }
      if (scrollTop > 0) {
        this.isTop = true;
        item [this.num].classList.add("active-hover");
      }else{
        this.isTop = false;
        item[this.num].classList.remove("active-hover");
        item[this.num].classList.add("active");
      }
    },
    //鼠标移入
    mouseOver(index) {
      this.isTop = true;
      this.num = index;
    },
    mouseLeave() {
      this.isTop = false;
      this.num = this.val;
      item[this.val].classList.remove("active-hover");
    },
    //点击导航
    handleClick(index) {
      this.val = index;
    },
    hover() {
      this.isTop = true;
      item[this.num].classList.add("active-hover");
    },
    leave() {
      if (this.newTop > 0) {
        this.isTop = true;
      } else {
        this.isTop = false;
        item[this.val].classList.remove("active-hover");
      }
    },
    //返回顶部
    goUp(){
      document.documentElement.scrollTop=0;
      window.pageYOffset=0;
      document.body.scrollTop=0;
    }
  },
  mounted() {
    window.addEventListener("scroll", this.getScroll, false);
  },
  destroy() {
    window.removeEventListener("scroll", this.getScroll, false);
  },
};
</script>

<style lang="less" scoped>
@line-color: #f85148;
@white: #fff;
@nav-bg: #1e2430;
.seTbtn(@bgColor,@ftColor,@width,@height,@site,@lh,@border,@ftSize) {
  background-color:rgba(246,82,72,@bgColor);
  color: @ftColor;
  width: @width;
  height:@height;
  text-align: @site;
  line-height: @lh;
  border-radius: @border;
  margin: 9px 0 0 30px;
  font-weight: @ftSize;
  cursor: pointer;
}
.ny-container-header {
  width: 100%;
  z-index: 99999;
  background: none;
  margin: 0 auto;
  padding: 10px 0;
  position: fixed;
  top: 0;
  left: 0;
  .details {
    width: 1240px;
    padding: 0 20px;
    height: 100%;
    margin: 0 auto;
  }
}
.ny-container-header-left {
  min-width: 800px;
  flex: 1;
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  .logo {
    display: inline-block;
    width: 100px;
    margin-right: 60px;
    cursor: pointer;
  }
  .active {
    border-bottom: 2px solid @white !important;
  }
  .active-hover {
    border-bottom: 2px solid @line-color !important;
  }
  .item {
    position: relative;
    display: inline-block;
    font-size: 0.9rem;
    margin: 0 20px;
    color: @white;
    cursor: pointer;
    font-weight: 700;
    padding: 15px 0;
    border-bottom: 2px solid transparent;
  }
}
.ny-container-header-right {
  height: 100%;
  .title {
    color: @white;
    font-size: 0.9rem;
    // line-height: 1.4rem;
    .hot {
      color: @line-color !important;
    }
    p {
      font-weight: 700;
      padding:15px 0;
    }
    .btn {
      display: block;
      .seTbtn(0,#fff,80px,25px,center,25px,2px,700);
    }
    .btn-active {
      .seTbtn(1,#fff,80px,25px,center,25px,2px,700);
    }
 
  }
}
.bg-color {
  background-color: @nav-bg;
}
.fixed-up {
  position: fixed;
  bottom: 160px;
  right: 20px;
  width: 100%;
  height: 0;
  max-width: 1450px;
  padding: 0 20px;
  .centent {
    width: 46px;
    .item {
    width: 100%;
    height: 46px;
    border-radius: 3px;
    background: linear-gradient(90deg,#fe5d39,#f22e30,#d61538);
    margin-top: 10px;
    z-index: 999;
    .logo {
      width: 30px;
      height: 30px;
      background: url('../assets/top.png') 50%;
      background-size: 100% 100%;
    }
    }
  }
}
</style>

